import {ready} from '../main/utils';
import Vue from '../main/vue';
import WhitePaperRegistration from './WhitePaperRegistration.vue';

ready(() => {
  if (document.querySelector('#white-paper-root')) {
    new Vue({
      el: document.querySelector('#white-paper-root'),
      comments: true,
      components: {
        'slo-white-paper-registration': WhitePaperRegistration
      }
    });
  }
});
